import styled from 'styled-components';
import Button from '@components/Button';

export const Container = styled.div`
  width: 100%;
  padding: 16px 6px;
  .MuiInputBase-input {
    line-height: 1.5rem;
    font-family: 'Inter', semi-bold;
  }

  .MuiTypography-alignCenter {
    font-family: 'Inter', semi-bold;
  }

  .MuiOutlinedInput-root {
    border-radius: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h2`
  color: ${({ theme }) => theme.font_secondary};
  font-size: 1.25rem;
  font-weight: 600;
  font-family: 'Inter', semi-bold;
  margin: 0;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.125rem;
`;

export const Legend = styled.p`
  color: ${({ theme }) => theme.font_secondary};
  font-size: 0.75rem;
  font-family: 'Inter', regular;
  margin: 0.5rem 0 1.5rem 0;
`;

export const Footer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-top: 3rem;
`;

export const CancelButton = styled(Button)`
  button.MuiButton-outlined {
    border-radius: 8px;
    color: ${({ theme }) => theme.font_secondary};
    border-color: ${({ theme }) => theme.font_secondary};
  }
`;

export const IntegrateButton = styled(Button)`
  button.MuiButton-contained {
    border-radius: 8px;
  }
`;
